module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3aec74140126f59247a5513ff0541125.png";